// extracted by mini-css-extract-plugin
module.exports = {"DefaultPage":"DefaultPage_DefaultPage__IFXez","PostPageContainer":"DefaultPage_PostPageContainer__ioeol","PostFullPageContainer":"DefaultPage_PostFullPageContainer__kOJUR"};